export const MAX_PRESENTATION_UPLOAD_BYTES = 50 * 1024 * 1024;
export const AVATAR_MAX_BYTES = 10 * 1024 * 1024;
export const QR_LOGO_MAX_BYTES = 4 * 1024 * 1024;

export const NAME_MAX = 50;
export const MESSAGE_MAX = 4000;
export const BIO_MAX = 70;
export const THANKS_MAX = 90;

export const KEY_TAKEAWAY_HEADING_MAX = 96;
export const FAQ_CATEGORY_MAX = 40;
export const FAQ_QUESTION_MAX = 130;
export const FAQ_ANSWER_MAX = 500;
export const MAX_ITEMS_PER_CATEGORY = 5;
export const TOC_MAX_LEVEL = 2;

export const EXPIRING_THRESHOLD_DAYS = 7;
